export const FILTER_SIGN_ITEMS = ['>', '<', '>=', '<='];

export const TH = 1e12; // 1 Terahash = 1000000000000 H
export const MH = 1e6; // 1 Megahash = 1000000 H

export const FILTER_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  WITH_ISSSUES: 'withIssues',
}

export const FILTER_STATUSES_LENGTH = Object.keys(FILTER_STATUS).length;

type FilterStatusType = keyof typeof FILTER_STATUS;

export const FILTER_SIGN_OPTIONS = FILTER_SIGN_ITEMS.map((sign: string) => {
  return { label: sign, value: sign };
});

export type FilterSignType = typeof FILTER_SIGN_ITEMS[number];

export type FiltersSchema = {
  search: string;
  status: FilterStatusType;
  hashrate: number;
  sharesStale: number;
  sharesInvalid: number,
  hashrateSign: FilterSignType;
  sharesStaleSign: FilterSignType;
  sharesInvalidSign: FilterSignType;
};

export const filterSignCompare = (one: number, two: number, task: FilterSignType) => {
  switch (task) {
    case FILTER_SIGN_ITEMS[0]:
      return one > two
    case FILTER_SIGN_ITEMS[1]:
      return one < two
    case FILTER_SIGN_ITEMS[2]:
      return one >= two
    case FILTER_SIGN_ITEMS[3]:
      return one <= two
    default:
      return true;
  }
}